import * as React from "react";
const SvgFiRrRankingPodium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ranking-podium_svg__a)">
      <path
        fill="#062147"
        d="M20.5 16H17v-3.5c0-1.93-1.57-3.5-3.5-3.5h-3C8.57 9 7 10.57 7 12.5v.5H3.5C1.57 13 0 14.57 0 16.5v4C0 22.43 1.57 24 3.5 24h17c1.93 0 3.5-1.57 3.5-3.5v-1c0-1.93-1.57-3.5-3.5-3.5M9 12.5c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5V22H9zm-7 8v-4c0-.827.673-1.5 1.5-1.5H7v7H3.5c-.827 0-1.5-.673-1.5-1.5m20 0c0 .827-.673 1.5-1.5 1.5H17v-4h3.5c.827 0 1.5.673 1.5 1.5zm0-9a.5.5 0 0 0-.5-.5H21a1 1 0 1 1 0-2 .5.5 0 0 0 0-1h-2a1 1 0 1 1 0-2h2a2.503 2.503 0 0 1 2.206 3.675c.488.456.794 1.105.794 1.825 0 1.379-1.122 2.5-2.5 2.5H19a1 1 0 1 1 0-2h2.5a.5.5 0 0 0 .5-.5M4 6a1.001 1.001 0 0 0-2 0 1 1 0 0 1-2 0c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.364-1.267 2.275-2.538 3H5a1 1 0 1 1 0 2H1.608C.843 11 .232 10.584.05 9.94c-.188-.67.138-1.374.83-1.795.25-.152.552-.315.876-.49C2.312 7.355 4 6.444 4 6m5.293-2.92a1 1 0 0 1 0-1.414L10.535.424a1.44 1.44 0 0 1 1.574-.312c.542.225.89.748.89 1.334V7a1 1 0 1 1-2 0V2.787l-.292.293a1 1 0 0 1-1.414 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ranking-podium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRankingPodium;
